module.exports = __webpack_public_path__ + "images/pages/kaitori_bonus_cp_lp/august/mainvisual-bg-pc_5d9585daf5d6be86cdadd71d05cb03f7.png";